import { Box, SxProps, Divider } from '@mui/material';
import { OrganizationHeader } from 'modules/home/components/OrganizationHeader';
import { PropsWithChildren } from 'react';
import { useRecoilValue } from 'recoil';
import { organizationAtom } from 'services/organization/atom';
import { NavTabs } from 'common/ui';
import { useIsAdmin } from 'hooks/useIsAdmin';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';
import { getHomeTabs } from '../utils/getHomeTabs';

const layoutContainerSx: SxProps = {
  pt: '20px',
  pb: '100px',
  px: '50px'
};

const tabsContainerSx: SxProps = {
  display: 'flex',
  alignItems: 'center'
};

const dividerSx: SxProps = {
  height: 1,
  mt: 4,
  mb: 5,
  borderColor: 'border.small.grey.medium'
};

export const HomeLayout = ({ children }: PropsWithChildren) => {
  const organization = useRecoilValue(organizationAtom);
  const hasCalendarIntegration = organization?.hasCalendarIntegration;
  const { isAdmin } = useIsAdmin();

  const hasDocumentTypesEnabled = !!useFlag(Flags.DOCUMENT_TYPES);

  const tabs = getHomeTabs({
    isAdmin,
    hasCalendarIntegration: !!hasCalendarIntegration,
    hasDocumentTypesEnabled
  });

  return (
    <Box sx={layoutContainerSx}>
      <OrganizationHeader organizationName={organization?.name || ''} />
      <Box sx={tabsContainerSx}>
        <Box sx={{ flex: 1 }}>
          <NavTabs tabs={tabs} />
        </Box>
      </Box>
      <Divider variant="fullWidth" flexItem sx={dividerSx} />
      <Box>{children}</Box>
    </Box>
  );
};
